const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  shop_id: state => state.user.shop_id,
  shop_domain_prefix: state => state.shop.shop_domain_prefix
}
export default getters
